/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAccessibilityNewIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-accessibility-new"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.95 5.9Q11.95 5.9 11.47 5.9Q11 5.9 10.35 5.25Q9.7 4.6 9.7 3.65Q9.7 2.7 10.35 2.05Q11 1.4 11.95 1.4Q12.9 1.4 13.55 2.05Q14.2 2.7 14.2 3.65Q14.2 4.6 13.55 5.25Q12.9 5.9 11.95 5.9ZM8.45 21.07L8.45 9.45Q7.28 9.35 6.06 9.16Q4.85 8.97 3.65 8.7Q3.08 8.57 2.76 8.09Q2.45 7.6 2.58 7.03Q2.7 6.45 3.23 6.19Q3.75 5.92 4.33 6.05Q6.13 6.42 8.1 6.61Q10.07 6.8 11.95 6.8Q13.82 6.8 15.84 6.61Q17.85 6.42 19.68 6.05Q20.25 5.92 20.77 6.19Q21.3 6.45 21.43 7.03Q21.55 7.6 21.24 8.09Q20.93 8.57 20.35 8.7Q19.15 8.97 17.94 9.16Q16.73 9.35 15.55 9.45L15.55 21.07Q15.55 21.63 15.16 22.01Q14.78 22.4 14.22 22.4Q13.68 22.4 13.29 22.01Q12.9 21.63 12.9 21.07L12.9 16.4L11.1 16.4L11.1 21.07Q11.1 21.63 10.71 22.01Q10.32 22.4 9.78 22.4Q9.22 22.4 8.84 22.01Q8.45 21.63 8.45 21.07Z" fill={color} />
    </svg>
  );
}
